(function( $ ) {
	var set_footer_widget_height = function() {
		var e = 0;
		var t = $( "#footer-top .footer-widget" );
		t.each( function( t, h ) {
			$( h ).height() > e && (e = $( h ).height())
		} );
		t.height( e );
	};

	$( document ).ready( function( $ ) {
		set_footer_widget_height();

		$( '#menu-main-navigation a' ).smoothScroll( {
			speed: 600,
			offset: -20,
		} );
	} );

	/* Sticky Header
	---------------------------------------------------------------------------------------------------- */
	var stickyNav = function() {
		var scrollTop = $( window ).scrollTop();
		if ( scrollTop > 10 + get_alert_bars_height() ) {
			$( '#nav-header' ).addClass( 'sticky' );
		} else {
			$( '#nav-header' ).removeClass( 'sticky' );
		}
	};

	stickyNav();

	$( window ).scroll( function() {
		stickyNav();
	} );

	function get_alert_bars_height() {
		var $alert_bars = $( '.alert-bar' ).not( '.alert-bar-footer' ).filter( ':visible' );
		var height = 0;

		if ( $alert_bars.length <= 0 ) {
			return height;
		}

		$alert_bars.each( function() {
			height += $( this ).outerHeight();
		} );

		return height;
	}

})( jQuery );